export const list = [

    {
        "guid": "938D9280-8E06-497A-9403-7344A3BF19B4",
        "situation": "地质工程、水文地质、构造地质等",
        "type": "勘察地质类",
        "number": 4,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:34:43",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },

    {
        "guid": "12FB992A-C2C7-4796-AC8B-A72107065F8A",
        "situation": "岩土工程、结构工程、地下工程等",
        "type": "土木工程类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:39:56",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "成都",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "12FB992A-C2C7-4796-AC8B-A72107065F8A",
        "situation": "岩土工程、结构工程、地下工程等",
        "type": "土木工程类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:39:56",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "成都",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "本科",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "12FB992A-C2C7-4796-AC8B-A72107065F8A",
        "situation": "道路与桥梁工程",
        "type": "土木工程类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:39:56",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "成都",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },

    {
        "guid": "2658E47E-9BA9-4269-84E7-2F4E5E7FD71D",
        "situation": "地理信息系统、遥感科学与技术测绘工程等",
        "type": "测绘地信类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:47:13",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "83AFF4F0-15DF-485C-8284-66EFC4BB78F7",
        "situation": "地理信息系统、遥感科学与技术测绘工程等",
        "type": "测绘地信类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:47:31",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "本科",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
  {
    "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
    "situation": "建筑学、城乡规划、风景园林等",
    "type": "建筑与市政设计类",
    "number": 2,
    "releaseTime": "2021-09-01",
    "addTime": "2021-09-01 17:54:22",
    "updateTime": "2021-09-01",
    "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
    "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
    "flag": 0,
    "endTime": null,
    "address": "北京",
    "zipCode": null,
    "linkman": null,
    "email": null,
    "degree": "硕士",
    "hot": 1,
    "enable": 1,
    "jobRequirements": "",
    "priorCondition": ""
  },
  {
    "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
    "situation": "电气工程、暖通工程等",
    "type": "建筑与市政设计类",
    "number": 2,
    "releaseTime": "2021-09-01",
    "addTime": "2021-09-01 17:54:22",
    "updateTime": "2021-09-01",
    "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
    "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
    "flag": 0,
    "endTime": null,
    "address": "北京",
    "zipCode": null,
    "linkman": null,
    "email": null,
    "degree": "硕士",
    "hot": 1,
    "enable": 1,
    "jobRequirements": "",
    "priorCondition": ""
  },

    {
        "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
        "situation": "地球物理勘探、固体地球物理等",
        "type": "物探工程类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:22",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "C3CAF00E-9A7B-4A96-A2C9-92D8695178B9",
        "situation": "环境工程、地下水科学与技术等",
        "type": "环境工程类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:06",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "C3CAF00E-9A7B-4A96-A2C9-92D8695178B9",
        "situation": "建筑环境与能源应用工程等",
        "type": "建筑能源类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:06",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "C3CAF00E-9A7B-4A96-A2C9-92D8695178B9",
        "situation": "建筑环境与能源应用工程等",
        "type": "建筑能源类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:06",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "本科",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },

    {
        "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
        "situation": "计算机科学与技术、软件工程、人工智能等",
        "type": "计算机类",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:22",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
        "situation": "工程管理、工程造价等",
        "type": "工程管理类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:22",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },
    {
        "guid": "16574981-B811-4D7A-97BE-ECA65D062428",
        "situation": "工程管理、工程造价等",
        "type": "工程管理类",
        "number": 1,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:54:22",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "本科",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    },

    {
        "guid": "E2BECCA9-DAB9-4713-B3BC-F6617D254D57",
        "situation": "汉语言文学、法学、经济学、管理学、新闻与传媒等",
        "type": "企业管理",
        "number": 2,
        "releaseTime": "2021-09-01",
        "addTime": "2021-09-01 17:55:53",
        "updateTime": "2021-09-01",
        "addUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "updateUser": "7E4CEF50-3ACA-4D0F-96FD-5C0C27C51DC5",
        "flag": 0,
        "endTime": null,
        "address": "北京",
        "zipCode": null,
        "linkman": null,
        "email": null,
        "degree": "硕士",
        "hot": 1,
        "enable": 1,
        "jobRequirements": "",
        "priorCondition": ""
    }
]
